import { McpSDK } from "./mcp"
import { homeFinancialSDK } from "./sdk"

class ChatSDK {
  #mcp: McpSDK

  constructor() {
    this.#mcp = new McpSDK(
      homeFinancialSDK.baseUrl,
      homeFinancialSDK.getAuthHeaders.bind(homeFinancialSDK)
    )
  }

  get mcp() {
    return this.#mcp
  }
}

export const chatSDK = new ChatSDK()
